import { createContext } from 'react';

import type { Identity } from '~/interfaces/identity';
import type { Integration } from '~/interfaces/integration';

/**
 * Tab-agnostic connected-accounts data — the subscriber's linked OAuth identities and the
 * available social-login providers (integrations). Lives at the composition root (not the
 * General tab) because the redirect handler it pairs with must run on every tab: a
 * `?billing_portal_error=1` bounce lands on the billing/groups tab. Consumed by the
 * General-tab `ConnectedAccountsModalContainer` (the modal) and profile card (which needs
 * `integrations` for its social-login links).
 */
export type IdentitiesContextType = {
  integrations: Integration[];
  identities: Identity[];
  subscriberId: string;
};

export const IdentitiesContext = createContext<IdentitiesContextType | undefined>(undefined);
IdentitiesContext.displayName = 'IdentitiesContext';
